export default __webpack_public_path__ + "static/media/punchy_kick_1.3c578201.mp3";